module.exports = ":host {\n  display: block; }\n\n.wrapper {\n  min-height: 100%;\n  height: auto !important;\n  height: 100%;\n  margin: 0 auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/app.component.scss
// module id = ./Frontend/src/app/app.component.scss
// module chunks = main